import {
  SupervisorAccount,
  Dashboard,
  FileCopy,
  SettingsApplications,
  GroupAdd,
  Business,
  WarningAmber,
  Report,
  Photo,
  Receipt,
  LocalShipping,
  Inventory,
  Upcoming,
  AccountTree,
  Grading,
  Devices,
  Handyman,
  QuestionAnswer,
  Help,
  CalendarMonthOutlined,
  AccountBalanceWallet,
  Warehouse,
  Engineering,
  HomeRepairService,
  ContactPage,
  RestoreFromTrash,
  Storefront,
  Contacts,
} from "@mui/icons-material";
import { urlRoutes } from "../constants/page";
import { permissionsCodes } from "../constants/users";

export const navItems = (permissions = {}) => {
  return [
    {
      name: "Dashboard",
      permissionName: "",
      path: urlRoutes.dashboard,
      icon: <Dashboard />,
    },
    ...(permissions?.canAccessCompanyProfilePage ||
    permissions?.u1 ||
    permissions?.p1 ||
    permissions?.l1
      ? [
          {
            name: "Admin",
            permissionName: "",
            icon: <SupervisorAccount />,
            subItems: [
              ...(permissions?.canAccessCompanyProfilePage
                ? [
                    {
                      name: "Company Profile",
                      permissionName: permissionsCodes.viewCompanyProfile,
                      path: urlRoutes.companyProfile,
                      icon: <SettingsApplications />,
                    },
                  ]
                : []),
              ...(permissions?.u1
                ? [
                    {
                      name: "Users",
                      permissionName: permissionsCodes.viewUsersPage,
                      path: urlRoutes.companyUsers,
                      icon: <GroupAdd />,
                    },
                  ]
                : []),
              ...(permissions?.p1
                ? [
                    {
                      name: "Positions",
                      permissionName: permissionsCodes.viewPositionsPage,
                      path: urlRoutes.companyPositions,
                      icon: <AccountTree />,
                    },
                  ]
                : []),
              ...(permissions?.l1
                ? [
                    {
                      name: "Locations",
                      permissionName: permissionsCodes.viewLocations,
                      path: urlRoutes.companyLocations,
                      icon: <Business />,
                    },
                  ]
                : []),
              ...(permissions?.gL1
                ? [
                    {
                      name: "GL Accounts",
                      permissionName: permissionsCodes.viewGLAccounts,
                      path: urlRoutes.glAccounts,
                      icon: <AccountBalanceWallet />,
                    },
                  ]
                : []),
              ...(permissions?.userDto?.email.includes("@linkstep.com")
                ? [
                    {
                      name: "Accounts",
                      permissionName: "canAccessCompanyProfilePage",
                      path: urlRoutes.accounts,
                      icon: <SettingsApplications />,
                    },
                  ]
                : []),
            ],
          },
        ]
      : []),
    ...(permissions?.canViewAuditPage ||
    permissions?.canViewSubmittedReports ||
    permissions?.canAccessIncidentFormsPage ||
    permissions?.r1 ||
    permissions?.r2 ||
    permissions?.r3 ||
    permissions?.r4
      ? [
          {
            name: "Reporting",
            permissionName: "",
            icon: <WarningAmber />,
            subItems: [
              ...(permissions?.canAccessIncidentFormsPage
                ? [
                    {
                      name: "Forms",
                      permissionName: "canAccessIncidentFormsPage",
                      path: urlRoutes.forms,
                      icon: <FileCopy />,
                    },
                  ]
                : []),
              // ...(permissions?.canAccessIncidentFormsPage
              //   ? [
              //       {
              //         name: "Report Scheduling",
              //         permissionName: "canAccessIncidentFormsPage",
              //         path: urlRoutes.reportScheduling,
              //         icon: <CalendarMonthOutlined />,
              //       },
              //     ]
              //   : []),
              ...(permissions?.canViewSubmittedReports ||
              (permissions?.canSubmitForms &&
                permissions?.canAccessIncidentFormsPage)
                ? [
                    {
                      name: "Incident Reports",
                      permissionName: permissions?.canViewSubmittedReports
                        ? "canViewSubmittedReports"
                        : "canAccessIncidentFormsPage",
                      path: urlRoutes.incidentReports,
                      icon: <Report />,
                    },
                  ]
                : []),
              ...(permissions?.canViewAuditPage
                ? [
                    {
                      name: "Audit Reports",
                      permissionName: "canViewAuditPage",
                      path: urlRoutes.auditReports,
                      icon: <Grading />,
                    },
                  ]
                : []),
              ...(permissions?.r1
                ? [
                    {
                      name: "Support Tickets",
                      permissionName: "r1",
                      path: urlRoutes.itTicketing,
                      icon: <Devices />,
                    },
                  ]
                : []),
              ...(permissions?.r2
                ? [
                    {
                      name: "Maintenance Requests",
                      permissionName: "r2",
                      path: urlRoutes.maintenanceRequests,
                      icon: <Handyman />,
                    },
                  ]
                : []),
              ...(permissions?.r3
                ? [
                    {
                      name: "Surveys",
                      permissionName: "r3",
                      path: urlRoutes.surveys,
                      icon: <QuestionAnswer />,
                    },
                  ]
                : []),
              ...(permissions?.r4
                ? [
                    {
                      name: "Other",
                      permissionName: "r4",
                      path: urlRoutes.otherReports,
                      icon: <Help />,
                    },
                  ]
                : []),
            ],
          },
        ]
      : []),
    ...(permissions?.a1 || permissions?.a2
      ? [
          {
            name: "Assets",
            permissionName: "canAccessCompanyProfilePage",
            path: urlRoutes.assets,
            icon: <LocalShipping />,
            subItems: [
              ...(permissions?.a1
                ? [
                    {
                      name: "Assets",
                      permissionName: "a1",
                      path: urlRoutes.assets,
                      icon: <LocalShipping />,
                    },
                  ]
                : []),
              ...(permissions?.a2
                ? [
                    {
                      name: "Preventative Maintenance",
                      permissionName: "a2",
                      path: urlRoutes.preventativeMaintenance,
                      icon: <Engineering />,
                    },
                  ]
                : []),
              ...(permissions?.a2
                ? [
                    {
                      name: "Removed/Disposed Assets",
                      permissionName: "a2",
                      path: urlRoutes.disposedAssets,
                      icon: <RestoreFromTrash />,
                    },
                  ]
                : []),
            ],
          },
        ]
      : []),
    ...(permissions?.v1 || permissions?.v2
      ? [
          {
            name: "Vendors",
            permissionName: "a1",
            path: urlRoutes.vendors,
            icon: <Warehouse />,
            subItems: [
              ...(permissions?.v1 && [
                {
                  name: "Vendors",
                  permissionName: "v1",
                  path: urlRoutes.vendors,
                  icon: <Business />,
                },
              ]),
              ...(permissions?.v1 && [
                {
                  name: "Contacts",
                  permissionName: "v1",
                  path: urlRoutes.vendorContacts,
                  icon: <Contacts />,
                },
              ]),
            ],
          },
        ]
      : []),
    // {
    //   name: "Coming Soon",
    //   permissionName: "",
    //   icon: <Upcoming />,
    //   subItems: [
    //     {
    //       name: "Photo Gallery",
    //       permissionName: "",
    //       path: urlRoutes.photoGallery,
    //       icon: <Photo />,
    //     },
    //     {
    //       name: "Inventory Management",
    //       permissionName: "",
    //       path: urlRoutes.inventoryManagement,
    //       icon: <Inventory />,
    //     },
    //     {
    //       name: "Asset Management",
    //       permissionName: "",
    //       path: urlRoutes.assetManagement,
    //       icon: <LocalShipping />,
    //     },
    //     {
    //       name: "Receipt Tracker",
    //       permissionName: "",
    //       path: urlRoutes.receiptTracker,
    //       icon: <Receipt />,
    //     },
    //   ],
    // },
  ];
};
